import {
  FETCH_DIVISIONS,
  SET_DIVISIONS,
  SAVE_DIVISION_REQUEST,
  SAVE_DIVISION_SUCCESS,
  SAVE_DIVISION_FAILURE,
  DIVISION_SET_FILTER,
  DIVISION_MODAL_OPEN,
  DIVISION_MODAL_CLOSE,
  Division,
} from "./actions";

export interface DivisionState {
  list: Division[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
  modalOpen: boolean;
  editing: Division | null;
}

const initialState: DivisionState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,
  filterName: "",
  modalOpen: false,
  editing: null,
};

export default function divisionManagerReducer(
  state: DivisionState = initialState,
  action: any
): DivisionState {
  switch (action.type) {
    case FETCH_DIVISIONS:
      return { ...state, loading: true, error: undefined };
    case SET_DIVISIONS:
      return { ...state, loading: false, list: action.payload ?? [] };
    case SAVE_DIVISION_REQUEST:
      return { ...state, saving: true, error: undefined };
    case SAVE_DIVISION_SUCCESS:
      return { ...state, saving: false };
    case SAVE_DIVISION_FAILURE:
      return { ...state, saving: false, error: action.error };
    case DIVISION_SET_FILTER:
      return { ...state, filterName: action.payload ?? "" };
    case DIVISION_MODAL_OPEN:
      return { ...state, modalOpen: true, editing: action.payload ?? null };
    case DIVISION_MODAL_CLOSE:
      return { ...state, modalOpen: false, editing: null };
    default:
      return state;
  }
}